module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00090.50f2f46.png";